export default "__VITE_ASSET__30d4368c__"